import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsGitbookComponent } from './simple-icons-gitbook.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsGitbookComponent ],
    exports:      [ SimpleIconsGitbookComponent ],
    bootstrap:    []
})
export class SimpleIconsGitbookModule {}
